import { defineComponent } from 'vue'
import SaveBlockCode from '@/presentation/components/shared/save-block/save-block.code';

export default defineComponent({
	setup: () => {
		const code = new SaveBlockCode();

		return {
			pageName: code.pageName,
			isCampaignCreation: code.isCampaignCreation,
			isSaveEnabled: code.isSaveEnabled,
			isSaveOrCreationInProgress: code.isSaveOrCreationInProgress,
			doesPageSupportSaving: code.doesPageSupportSaving,
			saveCampaign: code.saveCampaign.bind(code),
			createCampaign: code.createCampaign.bind(code)
		};
	}
});
